import { Component, Prop, Vue } from 'vue-property-decorator';
import { MiFormField } from '@/components/MiForm/MiForm';
import { MonthFormatter } from '@/support/Date';
import { DateFormatter } from '@/support/DateFormatter';
import { ValidationRules, Rules } from '@/support/ValidationRules';

@Component<DatePicker>({})
export default class DatePicker extends Vue {
  @Prop()
  protected field!: MiFormField;

  protected date: DateFormatter | MonthFormatter | null = null;

  protected dateMenuTable = false;

  protected validationRules: Rules = ValidationRules();

  protected mounted(): void {
    if (! this.field) { return; }
    this.$nextTick(() => {
      this.createDateFormatter();
    });
  }

  protected createDateFormatter(): void {
    if (this.field.type === 'date') {
      this.date = new DateFormatter();
    }

    if (this.field.type === 'month') {
      this.date = new MonthFormatter();
    }

    if (this.date && this.field.value) {
      this.date.selectedDate = this.field.value as string;
    }
  }

  /**
   * Set field rules
   *
   * @protected
   * @param {MiFormField} field
   * @returns { void }
   * @memberof MiForm
   */
  protected fieldRules(field: MiFormField) {
    if (! field.rules) {
      return [];
    }

    const rules: Function[] = [];
    field.rules.forEach((rule: string) => {
      rules.push(this.validationRules[rule]);
    });

    return rules;
  }

  protected handleDateClear(field: MiFormField) {
    field.value = '';
    this.$emit('handleDateClear', field);
  }

  protected handleFieldChanged(field: MiFormField) {
    field.value = this.date ? this.date.selectedDate : '';
    this.$emit('handleFieldChanged', field);
  }
}
